import 'react-perfect-scrollbar/dist/css/styles.css'
import './assets/scss/index.scss'

import { CustomSnackbar } from './components'
import { LanguageSwitcher } from './components'
import { Provider } from 'react-redux'
import React from 'react'
import { Router } from 'react-router-dom'
import Routes from './Routes'
import { createBrowserHistory } from 'history'
import store from './redux/store'
import { useSelector } from 'react-redux'

const browserHistory = createBrowserHistory()

export default function App() {
  return (
    <Provider store={store}>
      {/* <CustomSnackbar /> */}
      <Router history={browserHistory}>
        {/* <LanguageSwitcher /> */}
        <Routes />
      </Router>
    </Provider>
  )
}
